import { render, staticRenderFns } from "./batchSelectAgent.vue?vue&type=template&id=25a31885&scoped=true&"
import script from "./batchSelectAgent.vue?vue&type=script&lang=js&"
export * from "./batchSelectAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a31885",
  null
  
)

export default component.exports